import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Alert, Button, Drawer } from '@stonelog/stonelog-design-system';
import { GingaIcon } from '@stonelog/stonelog-ginga-icons';
import { capitalizeMultipleFirstLetters } from '../../../../../../../../../utils/formatter';
import { removePreDeliveryPinsInWork, resetRequestPreDeliveriesStatus, resetSelectedPreDeliveryPins, resetSelectedRelocatePins, routesManagementSelector, setSimulationDataLocal } from '../../../../../../../../../features/senninha/routesManagementSlice';
import AutonomosSimulation from './AutonomosSimulation';
import { setMapWorkflow } from '../../../../../../../../../features/senninha/pinsSlice';
import { PreDeliverySimulationProvider } from '../../../../../../../../../context/preDeliverySimulationContext';
import { hubsSelector } from '../../../../../../../../../features/senninha/hubsSlice';
import machineError from "@assets/imgs/machine-error.svg";

import * as S from '../PreDelivery/styles';


const AutonomosComponent = ({ onClose, onCloseWithoutModal, setActiveKeyTab }) => {
    const dispatch = useDispatch();

    const {
        selectedHubInfos
    } = useSelector(hubsSelector);

    const {
        preDeliveryPinsInWork,
        statusSimulatePreDeliveries,
        errorSimulatePreDeliveries
    } = useSelector(routesManagementSelector);

    const handleDelete = (id_atendimento) => {
        dispatch(removePreDeliveryPinsInWork(id_atendimento))
    }
    const buildLocalSimulation = () => {
        const operadoresLogisticos = []
        const maisBarato = []
        const simulacoes = []

        preDeliveryPinsInWork.forEach((pin, pinIdx) => {
            const idSimulacao = `autonomo-${pin.id_referencia_visita || pinIdx}-${Math.random().toString(36).slice(2)}`
            const referenceKey = pin.id_referencia_visita

            const enderecoEntrega = {
                nick: pin.cliente,
                zipCode: pin.cep,
                city: pin.oss[0]?.cidade,
                neighborhood: pin.oss[0]?.referencia,
                addressNumber: pin.numero_endereco,
                address: pin.endereco,
                countryState: pin.uf,
                workingHours: null,
                reference: null,
                complement: pin.complemento,
                country: 'BRASIL'
            }

            operadoresLogisticos.push({
                id_simulacao: idSimulacao,
                reference_key: referenceKey,
                operador_logistico: 'Autônomo',
                valor: null,
                endereco_entrega: enderecoEntrega
            })

            maisBarato.push({
                id_simulacao: idSimulacao,
                reference_key: referenceKey,
                operador_logistico: 'Autônomo',
                valor: null,
                endereco_entrega: enderecoEntrega
            })

            simulacoes.push({
                id_simulacao: idSimulacao,
                reference_key: referenceKey,
                cliente: pin.cliente,
                operador_logistico: 'Autônomo',
                entregas: pin.oss.map((os) => ({
                    servico: os.servico,
                    numero_os: os.id_os,
                    info_os: 'Sem informações adicionais da OS.',
                    valor_mais_barato: null,
                    terminal_entrada: os.serial_entrada || '',
                    terminal_saida: os.serial_saida || '',
                    pos_recomendada: (os.tec_entrada || os.modelo_entrada)
                        ? `${os.tec_entrada || '-'} (${os.modelo_entrada || '-'})`
                        : '-',
                    id_atendimento: pin.id_atendimento,
                    contratante: pin.contratante,
                    previsao_entrega: '-',
                    endereco: pin.endereco,
                    defeito: '',
                    solucao: '',
                    suprimento: os.suprimento || '',
                    quantidade_suprimento: os.quantidade_suprimento || '',
                }))
            })
        })

        return {
            operadores_logisticos: operadoresLogisticos,
            mais_barato: maisBarato,
            simulacoes,
            endereco_polo: selectedHubInfos?.children || '',
            contato_distrital: ''
        }
    }

    const handleContinuar = () => {
        dispatch(resetRequestPreDeliveriesStatus())
        dispatch(setSimulationDataLocal(buildLocalSimulation()))
    }

    useEffect(() => {
        dispatch(setMapWorkflow('routesDrawer'))
    }, [])

    useEffect(() => {
        if (statusSimulatePreDeliveries === 'fulfilled') {
            dispatch(resetSelectedRelocatePins())
            dispatch(resetSelectedPreDeliveryPins());
            dispatch(setMapWorkflow('routesDrawer'))
        }
    }, [statusSimulatePreDeliveries])

    return (
        statusSimulatePreDeliveries === 'fulfilled' ? (
            <AutonomosSimulation
                onClose={onClose}
                onCloseWithoutModal={onCloseWithoutModal}
                setActiveKeyTab={setActiveKeyTab}
            />
        ) : (
            <>
                <Drawer.Body>
                    {preDeliveryPinsInWork.length ?
                        <>
                            <Alert
                                description="Os deliveries autônomos serão processados sem chamar a Stone Entrega, mantendo o técnico já definido na OS."
                                type="info"
                                className='ginga-lib-alert'
                            />

                            {preDeliveryPinsInWork.map((pin, i) => (
                                <Drawer.Row key={i} style={{ display: 'block' }}>
                                    <div style={{ display: 'flex' }}>
                                        <Drawer.RowText
                                            text={pin.cliente}
                                            description={`${capitalizeMultipleFirstLetters(pin.servico)} (OS ${pin.oss.map(({ id_os }) => `${id_os}`)})`}
                                        />
                                        <Drawer.RowActions>
                                            <Button
                                                type='negative'
                                                solid
                                                radius="99px"
                                                width="36px"
                                                height="36px"
                                                onClick={() => handleDelete(pin.id_atendimento)}
                                            >
                                                <GingaIcon name="trash" color="#E6171E" size={20} />
                                            </Button>
                                        </Drawer.RowActions>
                                    </div>
                                </Drawer.Row>
                            ))}
                        </>
                        :
                        statusSimulatePreDeliveries === 'rejected' ?
                            <Drawer.Response
                                element={<img src={machineError} />}
                                message={errorSimulatePreDeliveries ? errorSimulatePreDeliveries : "Houve um erro!"}
                            /> : <Drawer.Empty />
                    }
                </Drawer.Body>

                {!!preDeliveryPinsInWork.length &&
                    <Drawer.Footer>
                        <Button
                            type='primary'
                            width='100%'
                            height='52px'
                            size='large'
                            onClick={handleContinuar}
                            className="ginga-lib-button"
                        >
                            Continuar
                        </Button>
                    </Drawer.Footer>
                }
            </>
        )
    )
};

const Autonomos = (props) => (
    <PreDeliverySimulationProvider>
        <AutonomosComponent {...props} />
    </PreDeliverySimulationProvider>
)

export default Autonomos;
